import { IApplicationState } from 'setup/store'

import { defaultCurrency } from 'shared/constants'

export const selectIsUserAuthenticated = (state: IApplicationState) => state.auth.data.isAuth

export const selectAuthCommunication = (state: IApplicationState) => state.auth.communications

export const selectUserData = (state: IApplicationState) => state.auth.data.user

export const selectUserCurrency = (state: IApplicationState) => selectUserData(state)?.currency ?? defaultCurrency

export const selectPartnerId = (state: IApplicationState) => state.auth.data.partnerId

export const selectCheckPromocodeRegistrationComm = (state: IApplicationState) =>
  state.auth.communications.checkRegistrationValidate

export const selectSessionData = (state: IApplicationState) => state.auth.data.session

export const selectRefreshSessionCommunications = (state: IApplicationState) => state.auth.communications.refreshSession

export const selectAdditionalData = (state: IApplicationState) => state.auth.data.additionalData
